import type { AuthSession } from 'aws-amplify/auth'

export const getCognitoSubFromSession = (
  session: AuthSession | null | undefined
): string | null => {
  try {
    const sub = session?.tokens?.idToken?.payload?.sub
    return typeof sub === 'string' && sub.length > 0 ? sub : null
  } catch {
    return null
  }
}
